export default "__VITE_ASSET__CfH5A1cX__"